import PropTypes from 'prop-types'
import React from 'react'
import Button, { TYPES } from '../Button/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'

function getClassName (inPlaylist) {
  return ['playlist-edit']
    .concat(inPlaylist ? ['playlist-edit--add'] : [])
    .join(' ')
}

function PlaylistEdit (props) {
  const { inPlaylist, onClick } = props
  return (
    <div className={getClassName(inPlaylist)}>
      <Button
        type={TYPES.LINK}
        onClick={onClick}
        className={`playlist-edit__button playlist-edit__button--${inPlaylist ? 'add' : 'remove'}`}
      >
        <IconV2
          className="playlist-edit__icon"
          type={inPlaylist ? ICON_TYPES.PLUS : ICON_TYPES.CLOSE}
        />
      </Button>
    </div>
  )
}

PlaylistEdit.propTypes = {
  onClick: PropTypes.func.isRequired,
  inPlaylist: PropTypes.bool.isRequired,
}

export default PlaylistEdit
